import Vue from 'vue'
import VueWechatTitle from 'vue-wechat-title'


Vue.use(VueWechatTitle)